/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  BytesLike,
  BigNumberish,
  Overrides,
} from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../../../../../../common";
import type {
  ERC721ReceiverMock,
  ERC721ReceiverMockInterface,
} from "../../../../../../../../contracts/submodules/moar-locker/submodules/moar/contracts/mock/ERC721ReceiverMock";

const _abi = [
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "retval",
        type: "bytes4",
      },
      {
        internalType: "enum ERC721ReceiverMock.Error",
        name: "error",
        type: "uint8",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "gas",
        type: "uint256",
      },
    ],
    name: "Received",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "onERC721Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type ERC721ReceiverMockConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ERC721ReceiverMockConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ERC721ReceiverMock__factory extends ContractFactory {
  constructor(...args: ERC721ReceiverMockConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    retval: PromiseOrValue<BytesLike>,
    error: PromiseOrValue<BigNumberish>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<ERC721ReceiverMock> {
    return super.deploy(
      retval,
      error,
      overrides || {}
    ) as Promise<ERC721ReceiverMock>;
  }
  override getDeployTransaction(
    retval: PromiseOrValue<BytesLike>,
    error: PromiseOrValue<BigNumberish>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(retval, error, overrides || {});
  }
  override attach(address: string): ERC721ReceiverMock {
    return super.attach(address) as ERC721ReceiverMock;
  }
  override connect(signer: Signer): ERC721ReceiverMock__factory {
    return super.connect(signer) as ERC721ReceiverMock__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ERC721ReceiverMockInterface {
    return new utils.Interface(_abi) as ERC721ReceiverMockInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ERC721ReceiverMock {
    return new Contract(address, _abi, signerOrProvider) as ERC721ReceiverMock;
  }
}
